import React from "react";
import UpdateEmailCommon from "@clarion/feature/dist/Account/components/UpdateEmail/index";

const UpdateEmail = (props) => <UpdateEmailCommon {...props} />;

export default UpdateEmail;
